export enum FormFieldNamesEnum {
  StreetAddressOne = 'streetAddressOne',
  StreetAddressTwo = 'streetAddressTwo',
  City = 'city',
  CountryCode = 'countryCode',
  CompanyName = 'companyName',
  Email = 'email',
  State = 'state',
  FirstName = 'firstName',
  LastName = 'lastName',
  PostalCode = 'postalCode'
}
